import React from "react"
import { useLocation } from "react-router-dom"
import { Paths } from "#/utils/Paths"
import { DynamicContentToggles } from "./Toggles"
import { JsonConditionsToggles } from "./JsonConditionsToggles"

const JSON_CONDITIONS_PATHS: string[] = [Paths.FAQS]

function isJsonConditionsPath(pathname: string): boolean {
  return JSON_CONDITIONS_PATHS.some((base) => pathname === base || pathname.startsWith(`${base}/`))
}

export function DynamicContentTool(): JSX.Element {
  const { pathname } = useLocation()
  return isJsonConditionsPath(pathname) ? <JsonConditionsToggles /> : <DynamicContentToggles />
}
